import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative mx-auto max-w-[1286px] overflow-hidden rounded-[20px] pt-[94px] pb-18 pl-3 lg:mb-20 lg:rounded-[40px] lg:pt-25 lg:pr-7 lg:pb-3',
    bg: 'absolute top-0 left-0 z-0 h-full w-full object-cover',
    title:
      'text-brand-bioderma mb-5 px-3 text-center text-[28px] leading-[1.2] font-medium lg:mb-8 lg:text-[32px]',
    content: 'relative z-1',
    products: 'flex gap-3',
    carousel: '[--slide-spacing:12px] md:flex md:justify-center',
    product: 'flex h-full flex-col',
    productCard: 'h-full w-[295px]',
    top: 'mb-[38px] flex gap-4 max-lg:flex-col md:mb-10 md:gap-8 lg:mb-12 lg:items-center',
    heading: 'text-brand-bioderma text-[40px] leading-[1.2] font-medium',
    tabs: 'flex gap-2 rounded-[50px] border-2 border-white p-[6px] backdrop-blur-xl max-md:flex-col max-md:gap-2.5 md:items-center md:gap-2.5 md:rounded-[100px]',
    tab: 'flex-center flex h-[83px] cursor-pointer gap-3 rounded-[40px] pr-8 pl-[2px] md:h-20',
    tabImage: 'h-[76px] w-[76px] rounded-full object-cover',
    tabTitle: 'text-left text-lg leading-[1] font-medium uppercase md:mt-[2px]',
    imageWrapper:
      "relative block overflow-hidden rounded-[18px] border-x-1 border-y-3 border-white/80 bg-white/15 shadow-[inset_0_6px_28px_rgba(255,255,255,0.06),inset_0_-6px_28px_rgba(0,0,0,0.04),inset_0_0_1px_rgba(0,0,0,0.05)] backdrop-blur-xl backdrop-saturate-150 before:absolute before:inset-x-0 before:top-0 before:h-[60%] before:bg-gradient-to-b before:from-white/18 before:to-transparent before:opacity-80 before:blur-[1px] before:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-[60%] after:bg-gradient-to-t after:from-white/24 after:to-transparent after:opacity-70 after:blur-[1px] after:content-['']",
    step: 'text-brand-bioderma mb-5 flex h-10 justify-start gap-[1px] text-base lg:justify-center',
    stepNumber:
      'flex-center bg-white-100 border-white-100 flex h-10 rounded-[100px] border-x-1 border-y-2 px-[18px] backdrop-blur-xl',
    stepValue:
      'flex-center border-brand-bioderma flex h-10 rounded-[100px] border border-solid bg-white px-5 font-medium',
    arrowPrev:
      'text-brand-bioderma top-auto right-[calc(50%)] -bottom-17 left-auto !block bg-transparent max-md:-bottom-18',
    arrowNext:
      'text-brand-bioderma top-auto -right-3 -bottom-17 left-[calc(50%)] !block bg-transparent max-md:-bottom-18'
  },
  variants: {
    active: {
      true: {
        tab: 'bg-[#0077cf] text-white',
        tabTitle: 'text-white'
      },
      false: {
        tab: 'bg-white text-[#0077cf]',
        tabTitle: 'text-[#003A70]'
      }
    }
  },
  defaultVariants: {
    active: false
  }
});
